import React from "react";
import Axios from "axios";
import axios from "services/axios";
import { Button, Card, message, Spin, Tooltip, Tag } from "antd";
import MUIDataTable from "mui-datatables";
import { MuiThemeProvider, createMuiTheme } from "@material-ui/core/styles";
import { Link } from "react-router-dom";
import momentTZ from "moment-timezone";
import _ from "lodash";
import { getCarName, errorMessage } from "../../../../Utils";
import ModalDownload from "../../Component/Modal/ModalDownload";
import ModalReverse from "../../Component/Modal/ModalReverse";

let cancelToken;

class TradeInRequest extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      tradeIn: [],
      request: [],
      isLoading: true,
      confirmLoading: false,
      disableButton: true,
      openModal: false,
      fileList: null,
      page: 1,
      limit: 15,
      count: 0,
      search: "",
      sort: { name: "date", direction: "desc" },
      visibleModalDownload: false,
      visibleModalReverse: false,
      dataReverse: {},
    };
    this.visibleModalDownload = this.visibleModalDownload.bind(this);
    this.cancelRequest = this.cancelRequest.bind(this);
  }

  componentDidMount() {
    this.fetchTradeIn(this.state.page, this.state.limit);
  }

  componentDidUpdate(prevProps) {
    if (prevProps.match.params.status !== this.props.match.params.status) {
      this.setState({ isLoading: true, search: "", page: 1, limit: 15 }, () =>
        this.fetchTradeIn(1, 15)
      );
    }
  }

  orderBy(sort) {
    let key = "date";
    let value = "DESC";

    //Get Key
    if (sort.name === "Mobil Bekas") key = "carName";
    else if (sort.name === "Mobil Baru") key = "newCar";
    else if (sort.name === "Salesman") key = "salesman";
    else if (sort.name === "Hari/Tgl Request") key = "date";

    //Get Value
    if (sort.direction === "asc") value = "ASC";
    else if (sort.direction === "desc") value = "DESC";

    return `${key}=${value}`;
  }

  getStatus() {
    let status = this.props.match.params.status;
    if (!["rejected", "approved", "in-progress"].includes(status))
      status = null;
    return status;
  }

  async fetchTradeIn(page, limit) {
    const status = this.getStatus();
    if (status) {
      const order = this.orderBy(this.state.sort);
      const query = `${order}&&page=${page}&&limit=${limit}&&search=${
        this.state.search || ""
      }`;

      if (cancelToken) {
        cancelToken.cancel("Operation canceled due to new request");
      }
      cancelToken = Axios.CancelToken.source();

      const data = await axios
        .get(`admin-panel/trade-in/request/${status}?${query}`, {
          cancelToken: cancelToken.token,
        })
        .then(result => {
          this.setState({
            tradeIn: result.data.approvalTradeIn,
            page: result.data.page,
            limit: result.data.limit,
            count: result.data.count,
            isLoading: false,
          });
        })
        .catch(err => {
          if (!Axios.isCancel(err)) {
            errorMessage(err.response || err);
            this.setState({ isLoading: false });
          }
        });
    } else {
      message.error("Gagal request data trade in");
    }
  }

  reverseStatus(id) {}

  formatStatus(request) {
    switch (request.status) {
      case "Approved":
        return (
          <Tag color="green">
            {request.status} {request.status_label}
          </Tag>
        );
      case "Rejected":
        return (
          <Tag color="magenta">
            {request.status} {request.status_label}
          </Tag>
        );
      case "Dalam Proses":
        return (
          <Tag color="purple">Menunggu Persetujuan {request.status_label}</Tag>
        );
    }
  }

  changePage(page, limit) {
    this.setState({ isLoading: true });
    this.fetchTradeIn(page, limit);
  }

  formatRupiah(number) {
    const data = number.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".");
    return data;
  }

  getMuiTheme = () =>
    createMuiTheme({
      typography: {
        useNextVariants: true,
      },
      overrides: {
        MUIDataTableBodyCell: {
          root: {
            "white-space": "nowrap",
            "&:nth-child(1)": {
              width: "8em",
              "min-width": "8em",
              "max-width": "8em",
              "word-break": "break-all",
            },
          },
        },
      },
    });

  visibleModalDownload = val => {
    this.setState({ visibleModalDownload: val });
  };

  visibleModalReverse = (val, data) => {
    this.setState({ visibleModalReverse: val, dataReverse: data });
  };

  async cancelRequest(id) {
    this.setState({ confirmLoading: true });
    const data = await axios
      .put(`admin-panel/trade-in/cancel-request/${id}`)
      .then(result => {
        message.success("Berhasil cancel Request Approval");
        this.setState({
          confirmLoading: false,
          visibleModalReverse: false,
          isLoading: true,
        });
        this.fetchTradeIn(this.state.page, this.state.limit);
      })
      .catch(err => {
        message.error("Gagal Cancel Data Request");
        this.setState({
          isLoading: false,
          confirmLoading: false,
          visibleModalReverse: false,
        });
      });
  }

  render() {
    //Columns
    const columns = [
      {
        name: "Action",
        options: {
          sort: false,
        },
      },
      {
        name: "Status",
        options: {
          sort: false,
        },
      },
      {
        name: "Nomor Polisi",
        options: {
          sort: false,
        },
      },
      {
        name: "Mobil Bekas",
        options: {
          sort: true,
        },
      },
      {
        name: "Mobil Baru",
        options: {
          sort: true,
        },
      },
      {
        name: "No Booking",
        options: {
          sort: false,
        },
      },
      {
        name: "Salesman",
        options: {
          sort: true,
        },
      },
      {
        name: "Cabang",
        options: {
          sort: false,
        },
      },
      {
        name: "Area",
        options: {
          sort: false,
        },
      },
      {
        name: "Hari/Tgl Request",
        options: {
          sort: true,
        },
      },
    ];

    //Data New Car
    const tradeIn = this.state.tradeIn.map((item, idx) => {
      const carName = getCarName(item.ApprovalTradeIn.Appraisal.carDetail);
      const branch = item.ApprovalTradeIn.Appraisal.Booking.SalesProfile.Branch
        ? item.ApprovalTradeIn.Appraisal.Booking.SalesProfile.Branch.branch
        : null;
      const area = item.ApprovalTradeIn.Appraisal.Booking.SalesProfile.Branch
        ? item.ApprovalTradeIn.Appraisal.Booking.SalesProfile.Branch.area
        : null;
      return [
        <div>
          <Link
            to={{
              pathname: `/home/approval/trade-in-progress/${item.approvalTradeInId}`,
              query: { status: `request-${this.props.match.params.status}` },
            }}>
            <Tooltip placement="bottom" title="Detail Trade In">
              <Button icon="bars" style={{ marginRight: 10 }} />
            </Tooltip>
          </Link>
          {item && item.status !== "Rejected" && (
            <Tooltip placement="bottom" title="Reverse Status">
              <Button
                onClick={() => this.visibleModalReverse(true, item)}
                type="danger"
                icon="retweet"
              />
            </Tooltip>
          )}
        </div>,
        this.formatStatus(item),
        item.ApprovalTradeIn.Appraisal.licensePlate,
        carName,
        item.ApprovalTradeIn.NewCar
          ? item.ApprovalTradeIn.NewCar.carName
          : null,
        item.ApprovalTradeIn.Appraisal.Booking.noBooking,
        item.ApprovalTradeIn.Appraisal.Booking.SalesProfile.name,
        branch,
        area,
        momentTZ(item.updatedAt)
          .tz("Asia/Jakarta")
          .format("dddd, D MMMM YYYY HH:mm"),
      ];
    });

    //Options
    const options = {
      filter: false,
      responsive: "simple",
      fixedHeader: true,
      tableBodyHeight: "460px",
      print: false,
      selectableRows: "none",
      // resizableColumns: true,
      download: false,
      viewColumns: false,
      serverSide: true,
      rowsPerPage: parseInt(this.state.limit),
      count: this.state.count,
      page: this.state.page - 1,
      searchText: this.state.search,
      onTableChange: (action, tableState) => {
        switch (action) {
          case "changePage":
            this.changePage(tableState.page + 1, tableState.rowsPerPage);
            break;
          case "changeRowsPerPage":
            this.changePage(1, tableState.rowsPerPage);
            break;
          case "search":
            this.setState({ search: tableState.searchText }, () =>
              this.changePage(1, tableState.rowsPerPage)
            );
            break;
          case "sort":
            this.setState({ sort: tableState.sortOrder }, () =>
              this.changePage(1, tableState.rowsPerPage)
            );
            break;
          default:
            break;
        }
      },
    };

    return (
      <Card
        title="List Trade In Dalam Proses"
        style={{
          marginTop: 35,
          background: "#fff",
          minHeight: 360,
        }}>
        <div style={{ marginBottom: 10 }}>
          <Button onClick={() => this.visibleModalDownload(true)}>
            Download Report
          </Button>
        </div>

        <Spin size="large" spinning={this.state.isLoading} tip="Loading...">
          <MuiThemeProvider theme={this.getMuiTheme()}>
            <MUIDataTable
              title="List Trade In Dalam Proses"
              data={tradeIn}
              columns={columns}
              options={options}
            />
          </MuiThemeProvider>
        </Spin>

        <ModalDownload
          visible={this.state.visibleModalDownload}
          visibleModal={this.visibleModalDownload}
        />

        <ModalReverse
          confirmLoading={this.state.confirmLoading}
          data={this.state.dataReverse}
          type="request"
          visible={this.state.visibleModalReverse}
          cancelRequest={this.cancelRequest}
          visibleModal={this.visibleModalReverse}
        />
      </Card>
    );
  }
}

export default TradeInRequest;



// WEBPACK FOOTER //
// src/components/Dashboard/Approval/TradeIn/InProgress/TradeInRequest.js